import { restClient } from 'config/store/configureStore';

import { TRANSLATIONS_URL } from 'constants/ApiConstants';

export default {
  getTranslations: (language, params) =>
    restClient.get(TRANSLATIONS_URL, { params: { ...params, languages: language } }),

  // TODO - when this ticket is done, change https://fleetback.atlassian.net/browse/BMWVID-7628
  getTranslationsForAllLanguages: (languages, params) =>
    restClient.get(TRANSLATIONS_URL, { params: { ...params, languages: languages.join(',') } }),
};
